import { BlogSection } from '@/types/blog';

export const protectionSection: BlogSection = {
  id: 'schutzmechanismen',
  title: 'Schutzmechanismen: Wie du emotional resilient bleibst',
  content: `
    <p>
      Mit diesen Strategien kannst du dich vor emotionaler Manipulation in sozialen Medien schützen:
    </p>
    
    <ol class="space-y-3">
      <li>
        <strong>Bewusste Medienpause:</strong> Plane regelmäßige Auszeiten von sozialen Medien ein. Studien zeigen, dass schon 30 Tage Social-Media-Pause das emotionale Wohlbefinden verbessern können.
      </li>
      
      <li>
        <strong>Emotionscheck:</strong> Bevor du auf einen Finanzinhalt reagierst, frage dich: "Welche Emotion löst dieser Post in mir aus? Würde ich anders entscheiden, wenn ich mich neutral fühlen würde?"
      </li>
      
      <li>
        <strong>Zeitverzögerung:</strong> Lege eine "Bedenkzeit-Regel" fest – zum Beispiel 48 Stunden nachdenken, bevor du aufgrund von Social Media-Inhalten investierst.
      </li>
      
      <li>
        <strong>Diversifiziere deine Informationsquellen:</strong> Folge bewusst unterschiedlichen Perspektiven und nicht nur Accounts, die deine Meinung bestätigen.
      </li>
      
      <li>
        <strong>Algorithmus-Bewusstsein:</strong> Verstehe, dass dir Plattformen bevorzugt kontroverse, emotionalisierende Inhalte zeigen – nicht unbedingt die nützlichsten oder akkuratesten.
      </li>
    </ol>
    
    <p>
      Besonders wichtig: Entwickle eine gesunde Skepsis. Wenn etwas zu gut klingt, um wahr zu sein, ist es das meistens auch. Insbesondere bei Finanzthemen gibt es selten "revolutionäre Geheimnisse" oder "unentdeckte Strategien".
    </p>
  `
};
